define(function(require, exports, module) {
    'use strict';

    const StreetNameProvider = require('common/addressLookupSwiss/sourceProviders/streetNameProvider');
    const AbstractProvider = require('common/addressLookupSwiss/sourceProviders/abstractProvider');

    StreetNameProvider.prototype.format = function(row) {
        const inputTxt = this.lastInput.toLowerCase();
        return AbstractProvider.prototype.highlightResult.call(this, row.streetName, inputTxt);
    };

    module.exports = StreetNameProvider;
});
